import React from "react";
import './index.scss'

const HomeCard: React.FC<any> = (props) => {
    const {
        title = '',
        subTitle = '',
        link = '',
        imageUrl = '',
        imageBgType = ''
    } = props
    return (
        <div className={'home-card-container'}>
            <div className={`image-container ${imageBgType}`}>
            </div>
            <div className={'title'}>
                {title}
            </div>
            <div className={'sub-title'}>
                {subTitle}
            </div>
        </div>
    )
}

export default React.memo(HomeCard)